import cx from 'classnames';
import { Fragment } from 'react';
import { EpicSection, SectionHeader } from '@/vdp/styles';
import Sections from '~/constants/vdp/sections';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { useGetStandoutTierCategories } from '~/hooks/vdp/selectors/useCvnaCategories';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import CategoryCard from './CategoryCard';
import { Heading, Section } from './FeaturesAndHighlights.styles';
import HighlightCard from './HightlightCard';
import InstalledPackagesCard from './InstalledPackagesCard';
import useGetFeatureTourHighlights from './useGetFeatureTourHighlights';
import ViewDetailsButton from './ViewDetailsButton';

function FeaturesAndHighlights() {
  const standoutCategories = useGetStandoutTierCategories();
  const featureTourHighlights = useGetFeatureTourHighlights();
  const { installedPackages = [], parentModel } = useGetVehicleDetails();

  const showDivider = featureTourHighlights.length < 4;
  const shouldRender =
    standoutCategories.length > 0 || featureTourHighlights.length > 0;

  return shouldRender ? (
    <EpicSection
      id={Sections.FeaturesAndHighlights}
      data-nav-section={Sections.FeaturesAndHighlights}
    >
      <div className="px-2xl">
        <SectionHeader>
          {`why you\u2019ll love this`}
          <p>{parentModel}</p>
        </SectionHeader>
        <div
          className={cx(
            'mx-auto mt-4xl flex max-w-[1144px] flex-col items-center justify-start gap-4xl',
            {
              'm:divide-y m:divide-grey-2': showDivider
            }
          )}
        >
          {featureTourHighlights.length > 0 && (
            <Section>
              <Heading>Highlights</Heading>
              <div className="flex w-full flex-col gap-xl m:grid m:auto-rows-[minmax(0,_1fr)] m:grid-cols-2 l:grid-cols-3">
                {featureTourHighlights.map(({ title, ...rest }) => (
                  <HighlightCard key={title} title={title} {...rest} />
                ))}
              </div>
            </Section>
          )}

          {standoutCategories.length > 0 && (
            <Section className={cx('mb-8', { 'm:pt-4xl': showDivider })}>
              <Heading>Key Features</Heading>

              <div className="flex flex-col justify-start">
                <div className="grid w-full grid-cols-1 gap-y-[42px] m:grid-cols-3 m:gap-x-xl m:gap-y-3xl">
                  {standoutCategories.map(category => (
                    <Fragment key={category.name}>
                      <CategoryCard category={category} />
                    </Fragment>
                  ))}
                  {installedPackages.length > 0 && <InstalledPackagesCard />}
                </div>
              </div>

              <ViewDetailsButton />
            </Section>
          )}
        </div>
      </div>
    </EpicSection>
  ) : null;
}

export default withErrorBoundary(
  FeaturesAndHighlights,
  undefined,
  undefined,
  Sections.FeaturesAndHighlights
);
